import { render } from "./ventanaemergente_ingles.vue?vue&type=template&id=b98bf2d2&scoped=true"
import script from "./ventanaemergente_ingles.vue?vue&type=script&lang=js"
export * from "./ventanaemergente_ingles.vue?vue&type=script&lang=js"

import "./ventanaemergente_ingles.vue?vue&type=style&index=0&id=b98bf2d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b98bf2d2"]])

export default __exports__